import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

export const useStyles = makeStyles((theme: Theme) => ({
  hrLine: {
    border: '1px solid #E6E6E8',
  },
  //career
  profileCard: {
    marginTop: '10px',
    padding: '22px',
    boxShadow: 'none !important',
    borderRadius: '9px !important',
  },
  button: {
    width: '100%',
    marginTop: '20px !important',
    borderRadius: '6px !important',
    fontSize: '10.5px !important',
    backgroundColor: '#3061FF',
    boxShadow: 'none !important',
    color: '#373A45',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10.5px !important',
      marginTop: '5px !important',
    },
  },
  cardContainerReg: {
    borderRadius: '4px',
    padding: '12px',
    cursor: 'pointer',
    boxShadow: 'none !important',
  },
  cellBg: {
    background: 'rgba(255, 255, 255, 1)',
    border: '1px solid rgba(230, 230, 232, 1)',
    padding: '4px 12px',
    borderRadius: '50px',
  },
  cellTag: {
    height: '8px',
    width: '8px',
    borderRadius: '50px',
    background: 'rgba(220, 89, 89, 1)',
  },
  cellText: {
    fontSize: '12px',
    fontWeight: '400 !important',
    color: 'rgba(55, 58, 69, 1)',
  },
  cellsTags: {
    borderRadius: '50px',
    height: 'auto',
    padding: '4px 12px',
    fontSize: '14px',
    fontWeight: '500 !important',
    maxWidth: 'fit-content',
  },
  cellImg: {
    height: '94px',
    width: '94px',
    borderRadius: '4px',
    objectFit: 'cover',
  },
  registedredCardTitle: {
    fontSize: '14px',
    fontWeight: '500 !important',
    color: 'rgba(55, 58, 69, 1)',
  },
  registerEventsContainer: {
    padding: '0px 22px',
    height: '60vh',
    overflowX: 'hidden',
    overflowY: 'auto',
    boxShadow: 'none !important',
  },
  getStarted: {
    fontSize: '20px',
    fontWeight: '600 !important',
    color: '#373A45',
  },
  getStartedDesc: {
    fontSize: '16px',
    fontWeight: '400 !important',
    color: '#373A45',
  },
  viewidbutton: {
    width: '100%',
    marginLeft: '0px !important',
    borderRadius: '6px !important',
    padding: '7px !important',
    fontSize: '12px !important',
    fontWeight: '600 !important',
    backgroundColor: '#3061FF',
    marginTop: '10px !important',
    color: 'white !important',
    boxShadow: 'none !important',
    height: '4vh',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '9.5px !important',
    },
  },

  postJobBtns1: {
    width: '100%',
    borderRadius: '8px !important',
    padding: '10px !important',
    fontSize: '16px !important',
    fontWeight: '500 !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px !important',
      padding: '10px !important',
      width: '110px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
      padding: '8px !important',
      width: '100px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
      padding: '7px !important',
      width: '90px',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '30px !important',
      fontSize: '10px !important',
    },
  },
  carrierBox: {
    border: '0.75px solid #E6E6E8',
    borderRadius: '9px',
    padding: '18px',
    marginTop: 15,
  },
  postJobBtns: {
    width: '150px',
    borderRadius: '8px !important',
    padding: '7px !important',
    fontSize: '14px !important',
    fontWeight: '500 !important',
    color: '#373A45',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px !important',
      padding: '10px !important',
      width: '110px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
      padding: '8px !important',
      width: '100px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
      padding: '7px !important',
      width: '90px',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      borderRadius: '6px !important',
      height: '26px !important',
      width: '100px !important',
    },
  },
  postJobBtnsRecord: {
    width: '130px',
    borderRadius: '8px !important',
    padding: '7px !important',
    fontSize: '14px !important',
    fontWeight: '500 !important',
    color: '#373A45',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px !important',
      padding: '10px !important',
      width: '110px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
      padding: '8px !important',
      width: '100px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
      padding: '7px !important',
      width: '90px',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      borderRadius: '6px !important',
      height: '26px !important',
    },
  },
  postJobBtnsMsg: {
    width: '180px',
    borderRadius: '20px !important',
    padding: '7px !important',
    fontSize: '14px !important',
    fontWeight: '500 !important',
    color: '#373A45',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px !important',
      padding: '10px !important',
      width: '110px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
      padding: '8px !important',
      width: '100px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
      padding: '7px !important',
      width: '90px',
    },
  },
  preferBtns: {
    width: '100%',
    marginLeft: '0px !important',
    borderRadius: '6px !important',
    padding: '7px !important',
    fontSize: '12px !important',
    fontWeight: '500 !important',
    marginTop: '10px !important',
    color: '#373A45 !important',
    height: '4vh',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '9.5px !important',
    },
  },
  preferBtns1: {
    width: '100%',
    marginLeft: '0px !important',
    borderRadius: '6px !important',
    padding: '7px !important',
    fontSize: '12px !important',
    fontWeight: '500 !important',
    color: '#373A45 !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '30px !important',
      fontSize: '10px',
    },
  },
  iconBtns: {
    borderRadius: '8px !important',
    padding: '7px !important',
    fontSize: '14px !important',
    fontWeight: '500 !important',
  },
  profileDesignation: {
    fontSize: '12px !important',
    fontWeight: '500 !important',
    color: '#373A45',
    textAlign: 'left',
    width: '100%',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
  },
  referenceTitle: {
    fontSize: '12px !important',
    fontWeight: '500 !important',
    color: '#373A45',
    textAlign: 'left',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '11px !important',
    },
  },

  //Academic Records
  academicRecordBox: {
    backgroundColor: '#F6F8FB',
    marginTop: '10px',
    borderRadius: '12px',
    padding: '10px',
  },
  //Events
  eventsCardbox: {
    border: '0.75px solid #E6E6E8',
    borderRadius: '9px !important',
    padding: '18px !important',
    marginTop: 20,
  },
  //MentorShip
  mentorShipCard: {
    backgroundColor: '#F6F8FB',
    borderRadius: '9px !important',
    padding: '9px !important',
  },
  //Fundraise
  campaingsCard: {
    border: '0.75px solid #E6E6E8',
    marginTop: 10,
    borderRadius: 10,
    padding: 15,
  },
  campaingsCard1: {
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      height: '26vh',
    },
  },
  donation: {
    backgroundColor: '#F6F8FB',
    padding: 20,
    borderRadius: 12,
  },
  //Table container
  tableContainer: {
    border: '2px solid #E5E6EA',
    borderRadius: 10,
  },
  scrollableContent: {
    height: '12.5vh',
    overflowY: 'auto',
  },
  iconBox: {
    backgroundColor: '#E8EBF3',
    padding: '12px !important',
    borderRadius: '8px !important',
    cursor: 'pointer',
  },
  preferenceBox: {
    marginTop: '-20px',
    height: '19.5vh',
    [theme.breakpoints.up('xxl')]: {
      height: '22.5vh',
    },
    '@media (min-width: 1536px) and (max-width: 1636px)': {
      height: '20.8vh !important',
    },
    '@media (min-width: 1920px) and (max-width: 2000px)': {
      height: '30vh !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '7.5vh !important',
    },
  },
  verticalTabsList: {
    borderRight: '1px solid #E6E6E8',
    minWidth: '200px',
    '& .MuiTab-root': {
      textAlign: 'left',
      alignItems: 'flex-start',
      minHeight: '48px',
      padding: '12px 16px',
      fontSize: '14px',
      fontWeight: 500,
      color: '#666',
      textTransform: 'none',
      '&.Mui-selected': {
        color: '#2C58E8',
        backgroundColor: '#F5F7FF',
        borderRight: '3px solid #2C58E8',
      },
      '&:hover': {
        backgroundColor: '#F8F9FA',
      },
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
  },
  contentArea: {
    height: '95vh', // Match the sidenav height
    overflowY: 'auto',
    padding: '0px',
    [theme.breakpoints.down('md')]: {
      height: '95vh',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '92.7vh',
    },
  },
  tabsContainer: {
    flex: 1,
    marginBottom: '16px',
  },
  alumniCardContainer: {
    marginTop: 'auto',
  },
}));
